import { Component, OnInit  } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-modal-selecao-dbe',
  templateUrl: './modal-selecao-dbe.component.html',
  styleUrls: ['./modal-selecao-dbe.component.scss']
})
export class ModalSelecaoDBEComponent implements OnInit {
  loginAuth: string;
  env = environment;
  
  tipoProtocoloLista = [
    {
      id: 1,
      descricao: 'Abertura de Matriz', 
      linkHomol:'http://www.webhom.serpro.gov.br/redesim/inscricao/matriz',
      linkProd: 'https://www38.receita.fazenda.gov.br/redesim/inscricao/matriz',
    },
    {
      id: 2, 
      descricao: 'Abertura de Filial', 
      linkHomol:'http://www.webhom.serpro.gov.br/redesim/inscricao/filial',
      linkProd: 'https://www38.receita.fazenda.gov.br/redesim/inscricao/filial',
    },
    {
      id: 3, 
      descricao: 'Alterações da Pessoa Jurídica', 
      linkHomol:'http://www.webhom.serpro.gov.br/redesim/alteracao',
      linkProd: 'https://www38.receita.fazenda.gov.br/redesim/alteracao',
    },
    {
      id: 4, 
      descricao: 'Baixa da Pessoa Jurídica', 
      linkHomol:'http://www.webhom.serpro.gov.br/redesim/baixa',
      linkProd: 'https://www38.receita.fazenda.gov.br/redesim/baixa',
    }
  ];

  andamentoCNPJ = {
      descricao: 'Andamento da solicitação do CNPJ', 
      linkHomol:'http://hom.receita.fazenda.gov.br/PessoaJuridica/CNPJ/fcpj/consulta.asp',
      linkProd: 'https://servicos.receita.fazenda.gov.br/Servicos/fcpj/consulta.asp'
  }

  constructor(
    public activeModal: NgbActiveModal
  ) {
  }


  ngOnInit() {
    this.loginAuth = sessionStorage.getItem('loginAuth');
  }

  abrirLink(link) {
      window.open(link, '_blank')
  }

}
